export const PERIOD_LABEL = {
  'Every 86400 second': '매일',
}
